import React, { useState, useRef, useEffect } from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import { useLocation, useNavigate } from 'react-router-dom';
import NavbarText from '../components/NavbarText';
import { SmrtTBMDngrEval } from '../components/smartTBM/SmrtTBMDngrEval';
import Select from '../components/ui/Select';
import { Agrd, TBMEquipment, SmartTBMFileDataList, TBMFldAgnt, TBMMainDtl } from '../interface/Interface';
import * as securityHelper from "../helper/SecurityHelper";
import * as fn from '../api/FnSmartTBM';
import SmrtTBMAncmnt from '../components/smartTBM/SmrtTBMAncmnt';
import SmrtTBMSftyRul from '../components/smartTBM/SmrtTBMSftyRul';
import SmrtTBMChkList from '../components/smartTBM/SmrtTBMChkList';
import SmrtTBMsftyEdu from '../components/smartTBM/SmrtTBMsftyEdu';
import PassCard from '../components/modal/PassCard';
import Snackbar from '../components/Snackbar';
import axios from 'axios';
import { fn_deleteSmrtTbmData } from "../api/FnCmmn";
import {retrieveWrkDclrDtl} from "../api/FnSmartTBM";
import {logoutWC} from "../helper/SecurityHelper";

export default function SmartTBM() {
  const navigate = useNavigate();
  const location = useLocation();
  const smartTbmSeq = location.state.smartTbmSeq;
  const wrkDclrList = location.state.wrkDclrList;
  const sctrGb = location.state.sctrGb;
  const noneWrkDclr = location.state.noneWrkDclr;
  const evntSeq = location.state.evntSeq;
  const selectedExbtPlcList = location.state.selectedExbtPlcList;
  const equipList = location.state.equipList
  const doneTBM = location.state.doneTBM;
  const user = securityHelper.getLoginUser();
  const agrdInit = { 1: false, 2: false, 3: false, 4: false, 5: false }
  const [tab, setTab] = useState(1);
  const [agrd, setAgrd] = useState<Agrd>(agrdInit);
  const [selectPopup, setSelectPopup] = useState(false);
  const [selectData, setSelectData] = useState<string[]>([]);
  const [select, setSelect] = useState('');
  const [mainDtlData, setMainDtlData] = useState<TBMMainDtl>();
  const [fldAgntDataList, setFldAgntDataList] = useState<TBMFldAgnt[]>([]);
  const [dngrEvalDataList, setDngrEvalDataList] = useState<any>([]);
  const [wrkrInfoDataList, setWrkrInfoDataList] = useState([]);
  const [readWrkDclrList, setReadWrkDclrList] = useState([]);
  const dngrEvalRef = useRef<HTMLDivElement>();
  const [focus, setFocus] = useState(false);
  const [readAncmntList, setReadAncmntList] = useState<any>([]);
  const [ancmntData, setAncmntData] = useState<any[]>();
  const [readSftyRulList, setReadSftyRulList] = useState<any>([]);
  const [fileDataList, setFileDataList] = useState<SmartTBMFileDataList[]>([]);
  const [checked, setChecked] = useState<TBMEquipment>({ cap: true, belt: false, shoes: false });
  const [sftyEduDtlData, setSftyEduDtlData] = useState({});
  const [eduDataList, setEduDataList] = useState([]);
  const [readSftyEduList, setReadSftyEduList] = useState<any>([]);
  const [passCard, setPassCard] = useState(false);
  const [isTbmCmpltd, setIsTbmCmpltd] = useState(false);
  const [sftyRulDataList, setSftyRulDataList] = useState<any>([]);
  const [apprMemo, setApprMemo] = useState('');
  const videoRef = useRef<any>();
  const [endVideo, setEndVideo] = useState(false);
  const [snackbarTxt, setSnackbarTxt] = useState('');

  useEffect(() => { if (snackbarTxt) { setTimeout(() => setSnackbarTxt(''), 2000) } }, [snackbarTxt]);
  useEffect(() => {
    retrieveWrkDclrDtl({ setReadWrkDclrList, wrkDclrList, setSelect, setSelectData, noneWrkDclr });
    if (doneTBM) {
      const equipChk = equipList.split(',');
      for (let equip of equipChk) { checked[equip] = true };
      setChecked(checked);
    }
  }, []);

  const backEvent = async () => {
    if (tab === 1) {
      if (doneTBM) { navigate(-1); }
      else {
        if (window.confirm('진행중인 TBM 데이터가 삭제됩니다. TBM을 취소하고 로그아웃 하시겠습니까?')) {
          await fn_deleteSmrtTbmData(user.seq);
          securityHelper.logoutWC();
          return;
        }
      }
    } else {
      // setAgrd((prevState) => ({ ...prevState }));
      if (tab === 2) { setSelect(wrkDclrList[0].wrkInfo); }
      if (tab === 5) {
        if(!endVideo && videoRef.current.getState().player.ended) {
          setEndVideo(true);
        }
      }
      setTab((prevState) => prevState - 1);
    };
  };
  const selectHandler = (data: any) => {
    setSelect(data.wrkInfo);
    setSelectPopup(false);
    const wrkDclrSeq = Number(data.wrkDclrSeq)
    // @ts-ignore
    const newList = readWrkDclrList.concat(wrkDclrSeq);
    setReadWrkDclrList(newList);

    fn.retrieveDngrEvalDtl({ wrkDclrSeq, noneWrkDclr, setFldAgntDataList, setWrkrInfoDataList, setMainDtlData, setDngrEvalDataList, setApprMemo, sctrGb, evntSeq });
  };
  const nextHandler = () => {
    if (!doneTBM) {
      if (tab === 1) { if (!fn.tabOneMoveNext({ readWrkDclrList, wrkDclrList, dngrEvalRef, setFocus, setSnackbarTxt, noneWrkDclr, selectHandler })) { return; } }
      if (tab === 2) { if (!fn.tabTwoMoveNext({ readAncmntList, ancmntData, setSnackbarTxt })) { return; } }
      if (tab === 3) { if (!fn.tabThreeMoveNext({ readSftyRulList, sftyRulDataList, setSnackbarTxt })) { return; } }
      if (tab === 4) {
        if (!(checked['cap'])) { return setSnackbarTxt('안전모는 필수입니다. 체크해주세요'); }
      }
      // if (agrd[tab] === false) { return setSnackbarTxt('숙지 여부에 체크해 주십시오.'); }
    }
    setTab(tab + 1);
  };
  const doneHandler = async () => {
    if (doneTBM) { navigate('/main') }
    else if (eduDataList?.length !== 0 || !doneTBM) {
      if (!endVideo && (videoRef.current && !videoRef.current.getState().player.ended)) {
        setSnackbarTxt('영상을 끝까지 시청해주세요.');
        return;
      }
      if (!fn.tabFiveMoveNext({ readSftyEduList, eduDataList, setSnackbarTxt })) { return; }
      // if (agrd[5] === false) { return setSnackbarTxt('숙지 여부에 체크해 주십시오.'); }
    }
    let equipList = [];
    for (let key in checked) { checked[key] && equipList.push(key) };
    const equipChk = equipList.join();
    // await axios.post('admin/api/tbm/updateTbmCheck', { userSeq: user.seq, userName: user.name, userPhone: user.phone, authSeq: authSeq, wrkDclrSeqArr: wrkDclrSeqArr });
    const paramUser = user;
    const paramSmartTbmSeq = smartTbmSeq;
    let rsltCnt = await fn.updateSmrtTbmPrcsStat(paramUser, paramSmartTbmSeq, equipChk);
    if (rsltCnt > 0) {
      setPassCard(true);
      setIsTbmCmpltd(true);
    }
  };

  useEffect(() => { if (isTbmCmpltd && !passCard) { navigate('/main') } }, [passCard]);

  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      {passCard && <PassCard setPassCard={setPassCard} />}
      <NavbarText backEvent={backEvent}>개인 TBM</NavbarText>
      <Tab tab={tab} noneWrkDclr={noneWrkDclr} />
      {tab === 1 && !noneWrkDclr &&
        <div className='w-full flex justify-center items-center -mt-10 mb-10 md:-mt-[25px] md:mb-[25px]'>
          <Select selectHandler={selectHandler} select={select} selectPopup={selectPopup} setSelectPopup={setSelectPopup} selectData={selectData} focus={focus} seq >평가서</Select>
        </div>}
      <div id={"smart-tbm-area"} className={tab === 1 && !noneWrkDclr ? 'bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-177px)] md:h-[calc(100%-442px)]'
        : 'bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-152px)] md:h-[calc(100%-380px)]'}>
        <div className='mb-20 md:mb-[50px]'>
          {tab === 1 &&
            <SmrtTBMDngrEval ref={dngrEvalRef} doneTBM={doneTBM} agrd={agrd} setAgrd={setAgrd} mainDtlData={mainDtlData} fldAgntDataList={fldAgntDataList} wrkrInfoDataList={wrkrInfoDataList} noneWrkDclr={noneWrkDclr} sctrGb={sctrGb} evntSeq={evntSeq} wrkDclrList={wrkDclrList} setApprMemo={setApprMemo} apprMemo={apprMemo}
              setReadWrkDclrList={setReadWrkDclrList} setFldAgntDataList={setFldAgntDataList} setWrkrInfoDataList={setWrkrInfoDataList} setMainDtlData={setMainDtlData} setSelect={setSelect} setSelectData={setSelectData} dngrEvalDataList={dngrEvalDataList} setDngrEvalDataList={setDngrEvalDataList} selectedExbtPlcList={selectedExbtPlcList} />}
          {tab === 2 &&
            <SmrtTBMAncmnt doneTBM={doneTBM} agrd={agrd} setAgrd={setAgrd} ancmntData={ancmntData} setAncmntData={setAncmntData} fileDataList={fileDataList} setFileDataList={setFileDataList} setReadAncmntList={setReadAncmntList} readAncmntList={readAncmntList} sctrGb={sctrGb} />}
          {tab === 3 &&
            <SmrtTBMSftyRul doneTBM={doneTBM} agrd={agrd} setAgrd={setAgrd} setReadSftyRulList={setReadSftyRulList} readSftyRulList={readSftyRulList} fileDataList={fileDataList} setFileDataList={setFileDataList} sftyRulDataList={sftyRulDataList} setSftyRulDataList={setSftyRulDataList} sctrGb={sctrGb} />}
          {tab === 4 &&
            <SmrtTBMChkList doneTBM={doneTBM} agrd={agrd} setAgrd={setAgrd} checked={checked} setChecked={setChecked} />}
          {tab === 5 &&
            <SmrtTBMsftyEdu doneTBM={doneTBM} agrd={agrd} setAgrd={setAgrd} setSftyEduDtlData={setSftyEduDtlData} setEduDataList={setEduDataList} setReadSftyEduList={setReadSftyEduList} readSftyEduList={readSftyEduList} sftyEduDtlData={sftyEduDtlData} eduDataList={eduDataList} sctrGb={sctrGb} setSnackbarTxt={setSnackbarTxt} videoRef={videoRef} doneHandler={doneHandler} />}
        </div>
        <button onClick={tab !== 5 ? nextHandler : doneHandler} className='font-preLight text-15 md:text-37 text-white w-[265px] sm:w-[318px] md:w-[750px] h-43 md:h-[107px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto pt-10 pb-10 mb-20 md:pt-[25px] md:pb-[25px] md:mb-[50px]'>
          {tab === 1 ? !wrkDclrList || (wrkDclrList && wrkDclrList.length === 1) ? '모든 위험요인을 확인하고, 숙지하였습니다.' : readWrkDclrList.length < wrkDclrList.length ? '다음 평가서를 확인합니다.' : '모든 위험요인을 확인하고, 숙지하였습니다.'
          :tab === 2 ? '모든 공지사항을 확인하고, 숙지하였습니다.'
          :tab === 3 ? '모든 안전수칙을 확인하고, 숙지하였습니다.'
          :tab === 4 ? '보호구 착용에 대한 안내를 확인하였습니다.'
          :'모든 안전교육 내용을 확인하고, 숙지하였습니다.'}
        </button>
      </div>
    </div>
  );
};

const Tab = ({ tab, noneWrkDclr }: any) => {
  return (
    <div className={tab === 1 && !noneWrkDclr ? 'w-full h-82 md:h-[205px] flex flex-col justify-center px-17 md:px-[42px] top-52 md:top-[130px] bg-back text-13 sm:text-15 md:text-37'
      : 'w-full h-100 md:h-[250px] flex flex-col justify-center px-17 md:px-[42px] top-52 md:top-[130px] bg-back text-13 sm:text-15 md:text-37'}>
      <div className={tab === 1 ? 'flex items-center justify-evenly -mt-15 mb-10 md:-mt-[37px] md:mb-[25px]' : 'flex items-center justify-evenly mb-17 md:mb-[42px]'}>
        <p className={tab === 1 ? `text-point font-preLight` : `font-preLight`}>➀ 위험성평가서</p>
        <IoIosArrowForward className={tab === 1 ? `text-point` : ``} />
        <p className={tab === 2 ? `text-point font-preLight` : `font-preLight`}>➁ 공지사항</p>
        <IoIosArrowForward className={tab === 2 ? `text-point` : ``} />
        <p className={tab === 3 ? `text-point font-preLight` : `font-preLight`}>➂ 안전수칙</p>
      </div>
      <div className={tab === 1 ? 'flex items-center justify-evenly mx-40 md:mx-[100px]' : 'flex items-center justify-evenly mx-40 mb-17 md:mx-[100px] md:mb-[42px]'}>
        <IoIosArrowForward className={tab === 3 ? `text-point` : ``} />
        <p className={tab === 4 ? `text-point font-preLight` : `font-preLight`}>➃ 보호구</p>
        <IoIosArrowForward className={tab === 4 ? `text-point` : ``} />
        <p className={tab === 5 ? `text-point font-preLight` : `font-preLight`}>➄ 안전교육</p>
      </div>
    </div>
  );
};